/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Aria_ViewInputs */

const vi_common_aria_view = /** @type {(inputs: Common_Aria_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem`)
};

/**

* @param {Common_Aria_ViewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_aria_view = /** @type {((inputs?: Common_Aria_ViewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Aria_ViewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_aria_view(inputs)
});